import React, { useState } from 'react';
import { Box, Container, Typography, Grid, TextField, Button, Stack, Alert } from '@mui/material';
import { useCreateMessageMutation } from '../api/mutations/messages/create-message-mutation';
import SignUpforFreeChapter from '../components/SignUpforFreeChapter';
import Footer from '../components/Footer';

const Contact = () => {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', subject: '', body: '' });
  const [status, setStatus] = useState(null);
  const { mutateAsync, isLoading, isError, error } = useCreateMessageMutation();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    // Basic validation
    if (!form.firstName || !form.lastName || !form.email || !form.subject || !form.body) {
      setStatus('Please fill in all required fields.');
      return;
    }
    try {
      await mutateAsync({
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim(),
        subject: form.subject.trim(),
        body: form.body.trim(),
      });
      setStatus('Thanks! Your message has been sent.');
      setForm({ firstName: '', lastName: '', email: '', subject: '', body: '' });
    } catch (err) {
      setStatus('Could not send message. Please try again.');
    }
  };


  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary', width: '100%', alignItems: 'stretch' }}>
      <Box>
        <Stack spacing={3}>
          <Typography variant="h2" sx={{ fontSize: { xs: '2.2rem', md: '3rem' } }}>
            Contact Sara
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary' }}>
            Reach out with any questions, or start with the free chapter below.
          </Typography>
        </Stack>

        <Grid container spacing={4}  sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 2 }}>
              {status && <Alert severity="success">{status}</Alert>}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="First Name"
                    name="firstName"
                    value={form.firstName}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Last Name"
                    name="lastName"
                    value={form.lastName}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
              <TextField
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Subject"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Message"
                name="body"
                value={form.body}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={4}
                required
              />
              <Button type="submit" variant="contained" color="primary" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Message'}
              </Button>
              {isError && (
                <Alert severity="error">{error?.message || 'Error sending message.'}</Alert>
              )}
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <SignUpforFreeChapter />
          </Grid> */}
          <Grid item xs={12}>
            <Box sx={{ mt: 3, mb: 2, p: 2, bgcolor: 'custom.green', borderRadius: 2, textAlign: 'center' }}>
              <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                Join Our Community WhatsApp Group!
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Connect with other parents, get tips, and stay updated with the latest from Sara's Journal.
              </Typography>
              <Button
                variant="contained"
                bgcolor="custom.blue"
                href="https://chat.whatsapp.com/H2aqVIWLJQu1BkIA664xMV?mode=hqrc"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mt: 1 }}
              >
                Join Community WhatsApp
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Contact;